import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { AlertComponent } from '../components/alert/alert.component';
import { ConfirmComponent } from '../components/confirm/confirm.component';

@Injectable({
  providedIn: 'root',
})
export class MessagingService {
  constructor(private dialog: MatDialog) {}

  public alert(message: string, title?: string): Observable<any> {
    const dialogRef = this.dialog.open(AlertComponent, {
      width: '500px',
      data: {
        title,
        message,
      },
    });
    return dialogRef.afterClosed();
  }

  public confirm(message: string, title?: string, args?: any): Observable<boolean> {
    args = { ...{ width: '500px', primaryButtonText: 'Yes', hideCancel: false }, ...args };
    const dialogRef = this.dialog.open(ConfirmComponent, {
      width: args.width,
      data: {
        title,
        message,
        primaryButtonText: args.primaryButtonText,
        hideCancel: args.hideCancel,
      },
    });
    return dialogRef.afterClosed();
  }
}
